import React from 'react';
import CTMonitoringTooltipBody from './Components/CTMonitoringTooltipBody';
import UIStrings from '@/Utils/UIStrings';
import { useCreateRecruitmentContext } from '../../../../Create/Contexts/CreateRecruitmentContext';
import { getJobCategoryJobFunctionPair } from '@/Utils/JobFunctionSelectionUtils';
import { useAssessmentSettings } from '@/api/useAssessmentSettings';
import { TypographyH2 } from '@/Components/shadcn';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';

function SelectTestsStepHeader(): React.JSX.Element {
    const { data: assessmentSettings } = useAssessmentSettings();
    const {
        jobDetails: { jobFunctionId },
    } = useCreateRecruitmentContext();

    const { jobFunctionName } = getJobCategoryJobFunctionPair(assessmentSettings?.jobCategories ?? [], jobFunctionId);

    return (
        <div className="flex items-center justify-center">
            <div className="mx-auto flex w-full flex-col items-center justify-center gap-3 px-8 py-6">
                <div className="text-center">
                    <TypographyH2 className="text-foreground text-center tracking-tight">
                        {`${UIStrings.SkillsTestsForJobFunctionName(jobFunctionName ?? '')} `}
                    </TypographyH2>
                </div>
                <p className="text-foreground text-center align-middle text-base leading-relaxed">
                    {UIStrings.QuickSummaryRecommendationStep}
                    <InfoTooltip className="align-top" description={<CTMonitoringTooltipBody />} />
                </p>
            </div>
        </div>
    );
}

export default SelectTestsStepHeader;
